import type { EditorPlugin } from '../../../types/aha-editor';
import StrikethroughMarkPlugin from './StrikethroughMarkPlugin';
import MarkdownPlugin from '../../MarkdownPlugin/MarkdownPlugin';
import { markdownRegexpForMark } from '../../MarkdownPlugin/MarkdownUtils';

const StrikethroughMarkdownPlugin: EditorPlugin = {
  name: 'Strikethorugh markdown plugin',
  dependencies: [MarkdownPlugin, StrikethroughMarkPlugin],
  markdown: ['~', '~~'].map((char) => ({
    type: 'mark',
    mark: 'strikethrough',
    triggerCharacter: '~',
    regex: markdownRegexpForMark(char),
  })),
};

export default StrikethroughMarkdownPlugin;
